import { Component, ViewEncapsulation, input } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './email-not-delivered.component.less'],
  templateUrl: './email-not-delivered.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class EmailNotDeliveredTemplateComponent {
  public readonly data = input.required<WrappedValue<EmailNotDeliveredTemplateData>>();
}

export type EmailNotDeliveredTemplateData = {
  header: string;
  body_html: string;
  code_html: string;
  error_html: string;
};

export const EmailNotDeliveredTemplateMocks: EmailNotDeliveredTemplateData[] = [
  {
    header: 'Email not delivered',
    body_html: `Your message could not be delivered to <b>non-exist@example.com</b>. <br/>Check for typos or unnecessary spaces and try again.`,
    code_html: `<b>Codes</b>: 550, 5.5.0`,
    error_html: `<b>Errors</b>: No MX for example.com, domain accepts no mail`,
  },
];
